define('webshopMenuImagesView',[
  'module',
  'marionette',
  'underscore',
  'modalsAlertView',
  'entities/webshop/menu',
  'template!webshopMenuImagesView'
], function (
  Module,
  Marionette,
  _,
  AlertView,
  MenuApi,
  Tpl
) {
  'use strict';

  // Content of a ModalView: images of the webshop (S3 sections_images/), the chosen path goes in model.path.
  // options.images: [{path, name, url}], options.onUploaded(image)
  Module.exports = Marionette.ItemView.extend({
    template: Tpl,
    className: 'webshop-menu-images-view',

    ui: {
      search: '.mm-images-search',
      grid: '.mm-images-grid',
      file: 'input[type="file"]',
      uploadText: '.mm-upload .text'
    },

    events: {
      'input @ui.search': 'renderGrid',
      'click .mm-image-item': 'onSelect',
      'change @ui.file': 'onUpload'
    },

    initialize: function () {
      this.images = (this.options.images || []).slice();
    },

    onShow: function () {
      this.renderGrid();
    },

    renderGrid: function () {
      var q = $.trim(this.ui.search.val()).toLowerCase();
      var selected = this.model.get('path');
      var e = _.escape;
      var html = '';

      _.each(_.sortBy(this.images, 'name'), function (image) {
        if (q && image.name.toLowerCase().indexOf(q) < 0)
          return;
        html += '<div class="mm-image-item' + (image.path === selected ? ' selected' : '') + '" data-path="' + e(image.path) + '" title="' + e(image.name) + '">' +
          '<div class="mm-image-item-img"><img loading="lazy" src="' + e(image.url) + '"/></div>' +
          '<div class="mm-image-item-name">' + e(image.name) + '</div></div>';
      });

      this.ui.grid.html(html || '<div class="mm-images-empty">' + e(_.i18n('webshop.menu.images.empty', null, 'No image')) + '</div>');
    },

    onSelect: function (e) {
      this.$('.mm-image-item').removeClass('selected');
      $(e.currentTarget).addClass('selected');
      this.model.set('path', $(e.currentTarget).data('path'));
    },

    onUpload: function () {
      var file = this.ui.file[0].files[0];
      if (!file)
        return;
      var text = this.ui.uploadText.text();
      this.ui.uploadText.text(_.i18n('webshop.menu.images.uploading', null, 'Uploading...'));

      MenuApi.uploadImage(file).done(_.bind(function (image) {
        if (this.options.onUploaded)
          this.options.onUploaded(image);
        if (this.isDestroyed)
          return;
        this.images = _.reject(this.images, function (i) {
          return i.path === image.path;
        }).concat([image]);
        this.model.set('path', image.path);
        this.ui.search.val('');
        this.renderGrid();
      }, this)).fail(function (message) {
        AlertView.prototype.open('', message);
      }).always(_.bind(function () {
        if (!this.isDestroyed) {
          this.ui.uploadText.text(text);
          this.ui.file.val('');
        }
      }, this));
    }
  });
});

